import { Navigate } from 'react-router-dom';
import { isTokenValid } from '../utils/auth';

const ProtectedRoute = ({ children, requiredRoles }) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');

  const decodedToken = isTokenValid(token);

  // If token invalid or no role, redirect to login
  if (!decodedToken || !role) {
    localStorage.clear();
    return <Navigate to="/" replace />;
  }

  // Allow superadmin to access any protected route
  if (role === 'superadmin') {
    return children;
  }

  // If requiredRoles is defined, check if current role is allowed
  if (requiredRoles && !requiredRoles.includes(role)) {
    localStorage.clear();
    return <Navigate to="/" state={{ error: 'Forbidden', status: 403 }} />;
  }

  return children;
};

export default ProtectedRoute;
